const request = {
    invalid_input: 'الإدخال غير صالح. {{details}}',
    general: 'حدث خطأ في الطلب.',
    range_not_satisfiable: 'النطاق غير قابل للتحقق.',
};
export default Object.freeze(request);
